var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFingerprint = function SvgFingerprint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96.394,
    height: 76.645
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fingerprint_svg__b",
    x1: 48.252,
    x2: 48.252,
    y1: -0.591,
    y2: 73.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c6f73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#bcc8cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a0b2b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#bcc8cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c6f73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fingerprint_svg__c",
    x1: 18.643,
    x2: 47.267,
    y1: 5.334,
    y2: 37.225,
    gradientTransform: "rotate(-90 48.252 38.323)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fingerprint_svg__a",
    x1: 17.921,
    x2: 78.583,
    y1: 4.53,
    y2: 72.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02b2c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ea278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#fingerprint_svg__a",
    id: "fingerprint_svg__d",
    x1: 47.973,
    x2: 49.033,
    y1: 20.506,
    y2: 69.528
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fingerprint_svg__e",
    cx: 48.197,
    cy: 38.804,
    r: 61.385,
    gradientTransform: "matrix(1 0 0 .2218 0 30.198)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02b2c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#0daeb0",
    stopOpacity: 0.751
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#17aa9f",
    stopOpacity: 0.523
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#1fa791",
    stopOpacity: 0.335
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#26a586",
    stopOpacity: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#2aa37e",
    stopOpacity: 0.084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#2da27a",
    stopOpacity: 0.021
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ea278",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.645,
    height: 76.645,
    x: 9.93,
    fill: "url(#fingerprint_svg__b)",
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.646,
    height: 68.645,
    x: 13.93,
    y: 4.001,
    fill: "#093a3e",
    rx: 5,
    transform: "rotate(90 48.252 38.323)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66.646,
    height: 66.645,
    x: 14.93,
    y: 5.001,
    fill: "url(#fingerprint_svg__c)",
    rx: 4,
    transform: "rotate(90 48.252 38.323)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fingerprint_svg__a)",
    d: "M77.575 6a3.003 3.003 0 0 1 3 3v58.646a3.003 3.003 0 0 1-3 3H18.93a3.003 3.003 0 0 1-3-3V9a3.003 3.003 0 0 1 3-3zm0-1H18.93a4 4 0 0 0-4 4v58.646a4 4 0 0 0 4 4h58.645a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fingerprint_svg__d)",
    d: "M60.455 23.518a1 1 0 0 1-.483-.126 24.57 24.57 0 0 0-23.382 0 1.052 1.052 0 1 1-1.007-1.847 25.87 25.87 0 0 1 12.677-3.211 26.86 26.86 0 0 1 12.678 3.148 1.087 1.087 0 0 1 .44 1.448 1.01 1.01 0 0 1-.923.588m-30.036 11.02a1.048 1.048 0 0 1-.86-1.659 21.7 21.7 0 0 1 7.87-6.863 24.23 24.23 0 0 1 21.64-.021 21.6 21.6 0 0 1 7.871 6.821 1.067 1.067 0 0 1-1.72 1.26 19.4 19.4 0 0 0-7.116-6.213 22.12 22.12 0 0 0-19.73.02 20.06 20.06 0 0 0-7.136 6.192.89.89 0 0 1-.819.462m13.119 25.334a1.02 1.02 0 0 1-.735-.315 21.2 21.2 0 0 1-4.219-5.541 18.63 18.63 0 0 1-2.204-9.11c0-6.233 5.332-11.312 11.88-11.312s11.88 5.079 11.88 11.313a1.05 1.05 0 0 1-2.099 0c0-5.08-4.387-9.214-9.78-9.214s-9.782 4.134-9.782 9.214a16.3 16.3 0 0 0 1.952 8.06 19.6 19.6 0 0 0 3.883 5.1 1.08 1.08 0 0 1 0 1.49 1.2 1.2 0 0 1-.776.315m15.049-3.883a11.3 11.3 0 0 1-6.507-1.868 11.18 11.18 0 0 1-4.995-9.214 1.05 1.05 0 0 1 2.099 0 9.03 9.03 0 0 0 4.072 7.472 9.2 9.2 0 0 0 5.33 1.49 14 14 0 0 0 2.184-.21 1.036 1.036 0 0 1 1.217.86 1.057 1.057 0 0 1-.86 1.218 14.3 14.3 0 0 1-2.54.252m-4.219 4.324h-.273a16.8 16.8 0 0 1-7.808-4.45 15.28 15.28 0 0 1-4.554-10.956 6.472 6.472 0 0 1 12.929 0 4.376 4.376 0 0 0 8.731 0c0-7.913-6.821-14.336-15.217-14.336a15.28 15.28 0 0 0-13.874 8.459 13.5 13.5 0 0 0-1.238 5.877 20.9 20.9 0 0 0 1.406 7.577 1.024 1.024 0 0 1-.608 1.343 1.06 1.06 0 0 1-1.344-.609 23 23 0 0 1-1.532-8.311 15.8 15.8 0 0 1 1.427-6.8 17.42 17.42 0 0 1 15.763-9.656c9.53 0 17.316 7.367 17.316 16.435a6.472 6.472 0 0 1-12.929 0 4.376 4.376 0 0 0-8.731 0 13.22 13.22 0 0 0 3.925 9.466 14.08 14.08 0 0 0 6.863 3.862 1.073 1.073 0 0 1 .735 1.301 1.024 1.024 0 0 1-.987.798"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fingerprint_svg__e)",
    d: "M0 38.735c0 7.832 21.579 14.18 48.197 14.18s48.197-6.348 48.197-14.18Z"
  }))));
};
export default SvgFingerprint;